export const RING_GROUP_CALLER_ID_OPTIONS = Object.freeze({
  RG_NAME_CALLER_NUMBER: "RG_NAME_CALLER_NUMBER",
  CALLER_NUMBER_CALLER_NAME: "CALLER_NUMBER_CALLER_NAME",
  RG_NAME_EXTENSION: "RG_NAME_EXTENSION",
  DNIS_NAME_NUMBER: "DNIS_NAME_NUMBER",
});

export const CALL_QUEUE_CALLER_ID_OPTIONS = Object.freeze({
  CQ_NAME_CALLER_NUMBER: "CQ_NAME_CALLER_NUMBER",
  EXT_NAME_CALLER_NUMBER: "EXT_NAME_CALLER_NUMBER",
  CQ_NAME_EXTENSION: "CQ_NAME_EXTENSION",
  DNIS_NAME_NUMBER: "DNIS_NAME_NUMBER",
});

export const RING_BACK_MUSIC_CONTINUITY_OPTIONS = Object.freeze({
  NO_CONTINUITY: "NO_CONTINUITY",
  CONTINUITY_IN_GROUP: "CONTINUITY_IN_GROUP",
  CONTINUITY_ACROSS_GROUP: "CONTINUITY_ACROSS_GROUP",
});

export const RING_PATTERNS = Object.freeze({
  SIMULTANEOUS: "SIMULTANEOUS",
  SEQUENTIAL: "SEQUENTIAL",
  CYCLIC_REPETITIVE: "CYCLIC_REPETITIVE",
});

export const CALL_WAIT_PRIORITY_OPTIONS = Object.freeze({
  POSITION: "POSITION",
  NO_ACTION: "NO_ACTION",
  AVERAGE_WAIT_TIME: "AVERAGE_WAIT_TIME",
});

export const TIME_OUT_OPTIONS = Object.freeze({
  BACK_TO_QUEUE: "BACK_TO_QUEUE",
  TRANSFER: "TRANSFER",
  HANG_UP: "HANG_UP",
});

export const MAX_MEMBERS_PER_ROW = 20;

export const RING_GROUPS = "RING_GROUPS";
export const CALL_QUEUES = "CALL_QUEUES";
